import { Grid, Typography, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import { formatCurrency } from '@roc/ui/utils';
import { Amortization, PrePenaltyPayment, RateType } from './components/loanEconomicsFields';
import { LtvSlider } from './components/loanToValueSlider'
import { LoanRatesTable } from './components/loanRatesTable'
import { ItemDisplay } from '../properties/borrowerLoanSubmission/components/itemDisplay'
import { TitleDivider } from './components/titleDivider';
import { CustomizeYourQuote } from './components/customizeYourQuote';
import { useEffect, useState } from 'react';
import { DownloadableLoanRatesDialog } from '../quoteSummary/components/downloadableLoanRatesDialog';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    position: 'relative',
    maxWidth: '1080px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  loanAmount: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  loanRowTitle: {
    fontSize: '28px',
    fontWeight: 400,
  },
  customizeText: {
    fontSize: '14px',
    fontWeight: 400,
  },
  loanAmountValue: {
    fontSize: '32px',
    fontWeight: 500,
  },
  loanAmountLabel: {
    fontSize: '14px',
    fontWeight: 400,
  },
  dividerClassName: {
    backgroundColor: theme.palette.primary.main,

  }
}));
export const SinglePropertyLoanEconomicsForm = observer(
  ({
    store,
    loanEconomicsStore,
    onNext,
  }: any) => {
    const classes = useStyles();
    const [showQuoteDialog, setShowQuoteDialog] = useState(false);

    useEffect(() => {
      loanEconomicsStore.clearSelectedQuotes();
    }, [])

    return (
      <Grid
        container
        spacing={2}
        className={classes.container}
      >
        <Grid className={classes.loanAmount} item xs={4}>
          <ItemDisplay label={<Box className={classes.loanAmountLabel}>LOAN AMOUNT</Box>} value={<Box className={classes.loanAmountValue}>{formatCurrency(loanEconomicsStore?.loanAmount ?? 0)}</Box>}></ItemDisplay>
        </Grid>
        <Grid item xs={8}>
          <LtvSlider store={store} loanEconomicsStore={loanEconomicsStore} />
        </Grid>
        <Grid item xs={4}>
          <Amortization store={store} loanEconomicsStore={loanEconomicsStore} />
        </Grid>
        <Grid item xs={4}>
          <RateType store={store} loanEconomicsStore={loanEconomicsStore} />
        </Grid>
        <Grid item xs={4}>
          <PrePenaltyPayment store={store} loanEconomicsStore={loanEconomicsStore} />
        </Grid>
        <Grid item xs={12}>
          <Typography className={classes.loanRowTitle}>
            Choosing Loan Rates
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography className={classes.customizeText}>
            Click "Customize" to create a custom quote by modifying the loan terms, fees etc., and "Choose Option"
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <LoanRatesTable store={store} loanEconomicsStore={loanEconomicsStore} />
        </Grid>
        <TitleDivider title='Customize Your Quote' dividerClassName={classes.dividerClassName} />
        {loanEconomicsStore.displayedQuotes && loanEconomicsStore.displayedQuotes.map((selectedQ, i) => {
          return <CustomizeYourQuote store={store} quote={selectedQ} quoteIndex={i} loanEconomicsStore={loanEconomicsStore} onNext={onNext} onDownload={() => setShowQuoteDialog(true)} />
        })}
        <DownloadableLoanRatesDialog open={showQuoteDialog} onClose={() => setShowQuoteDialog(false)} />
      </Grid>
    );
  }
);
